enum TableNamesEnum {
  PotentialIssues = 'PotentialIssues',
  MissedRecalibrations = 'MissedRecalibrations',
  CompletedCalibrations = 'CompletedCalibrations',
  DataMismatch = 'DataMismatch',
}

export default TableNamesEnum;
